/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Tooltip } from "antd";
import MapPropsContext from "../MapPropsContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TI_MAP_LAYER_BUTTON } from "../../../Constants";

const MapLayerIcon = ({
  layerName,
  toolTip,
  fontAwesomeIcon,
  iconSrc,
  style,
  tooltipPlacement,
}) => {
  const { updateMapLayerNames, fiveG_layer } = useContext(MapPropsContext);

  const [isChecked, setIsChecked] = useState(false);

  const onClick = useCallback(() => {
    updateMapLayerNames("5G", false);

    setIsChecked((checked) => {
      updateMapLayerNames(layerName, !checked);
      return !checked;
    });
  }, []);

  //  이동통신 5G 무선국: 용도지역 레이어 위에 5G밀집도 레이어 올리기
  useEffect(() => {
    if (fiveG_layer && fiveG_layer === "5G") {
      updateMapLayerNames("5G", false);
      if (isChecked) {
        updateMapLayerNames("5G", true);
      } else {
        updateMapLayerNames("5G", true);
      }
    }
  }, [isChecked]);

  return (
    <Tooltip title={toolTip || layerName} placement={tooltipPlacement}>
      <div style={{ marginRight: 4, ...style }}>
        {iconSrc && (
          <div style={{ width: 33, height: 33 }} onClick={onClick}>
            <img src={iconSrc} alt="" />
          </div>
        )}
        {!iconSrc && fontAwesomeIcon && (
          <Button
            shape={"circle"}
            onClick={onClick}
            tabIndex={TI_MAP_LAYER_BUTTON}
            aria-label="용도지역"
          >
            <FontAwesomeIcon
              icon={fontAwesomeIcon}
              color={isChecked ? "#40a9ff" : undefined}
            />
          </Button>
        )}
      </div>
    </Tooltip>
  );
};

const WidgetMapLayerTypes = ({ style, tooltipPlacement }) => {
  const { layerWmsTypes } = useContext(MapPropsContext);

  return (
    <div style={{ ...style }}>
      {layerWmsTypes.map((layerWmsType, index) => {
        return (
          <MapLayerIcon
            {...layerWmsType}
            key={index}
            style={{ marginBottom: 3 }}
            tooltipPlacement={tooltipPlacement}
          />
        );
      })}
    </div>
  );
};

export default WidgetMapLayerTypes;
